module.exports = __webpack_public_path__ + "media/images/letters-8f2e4b7f2611cef485bd87512a02cdfe.png";